import React, { Component } from "react"

import { Chip } from "@cuba-go/poker-ui"


/* Component Rates */
class MobileRate extends Component {

    /* DRAW ANTE */
    _image = () => {

        /* Fields */
        const { ante, chips } = this.props

        /* Check Ante */
        if (ante) {
            return (
                <div className="chip-rate">
                    <Chip value={ante} chips={chips} size={74} />
                </div>
            )
        }
    }


    /* DRAW BET */
    _bet = () => {


        /* Fields */
        const { isBet, ante, gameScreen, chips } = this.props

        /* Style */
        const style = gameScreen ? "game" : ""

        /* Bet */
        if (isBet && ante) {
            return (
                <div className={`chip-rate chip-bet ${style}`}>
                    <Chip value={ante * 2} chips={chips} size={77} />
                </div>
            )
        }
    }


    /* Draw Bet Result */
    _betResult = () => {

        /* Fields */
        const { result, ante, chips } = this.props

        /* Check Result */
        if (result && result.betMultiplier && parseInt(result.betMultiplier) > 0) {
            return (
                <div className="chip-bet-result-multiplier-box-mobile">
                    <div className="chip-bet-result-rate-mobile">
                        <Chip value={ante * 2 * parseInt(result.betMultiplier)} chips={chips} size={77} />
                    </div>
                    <div className="chip-bet-result-multiplier-text-mobile">{result.betMultiplier}x</div>
                </div>
            )
        }

    }

    /* Draw Ante Result */
    _anteResult = (type) => {

        /* Fields */
        const { result, expressResult, ante, chips } = this.props

        const isWin = type === "ante" ? result && result.anteMultiplier && parseInt(result.anteMultiplier) > 0 : expressResult && expressResult.multiplier

        /* Check Result */
        if (isWin) {

            const multiplier = type === "ante" ? result.anteMultiplier : expressResult.multiplier
            const value = type === "ante" ? ante : ante * multiplier

            return (
                <div className="chip-bet-result-multiplier-box-mobile">
                    <div className="chip-ante-result-multiplier-text-mobile">{multiplier}x</div>
                    <div className="chip-ante-result-rate-mobile">
                        <Chip value={value} chips={chips} size={74} />
                    </div>
                </div>
            )
        }

    }

    /* Animation Chip when opened */
    _animation = () => {

        /* Fields */
        const { ante, isOpen, half, chips } = this.props

        /* Determine Ante value */
        let final = ante

        if (half) {
            final = ante / 2
        }

        /* Check Open */
        if (isOpen && final) {
            return (
                <div className="chip-open-animation-rate">
                    <Chip value={final} chips={chips} size={62} />
                </div>
            )
        }

    }

    /* Chip animations */
    _chipAnimations = () => {

        /* Fields */
        const { history, chips } = this.props

        /* Check History */
        if (history) {
            return (
                <div className="animations">
                    {history.map((animation, index) =>
                        <div key={`MOBILE-ANTE-${index}`} className="animated-chip">
                            <Chip value={animation.value} chips={chips} />
                        </div>
                    )}
                </div>
            )
        }

    }


    /* Insurance */
    _insurance = () => {

        /* Fields */
        const { insurance, insuranceStatus, chips } = this.props

        /* Insurance Status */
        let style = "chip-bottom-insurance-title"
        let title = "Страховка"

        if (insuranceStatus === "win") {
            style += " chip-bottom-insurance-success-title"
            title = "Страховка выиграла"
        }

        if (insuranceStatus === "lose") {
            style += " chip-bottom-insurance-fail-title"
            title = "Страховка проиграла"
        }

        /* Check Insurance */
        if (insurance && parseInt(insurance) > 0) {

            /* Determine Status */
            const winInsurance = insuranceStatus === "win" ? insurance * 2 : insurance
            const loseStyle = insuranceStatus === "lose" ? "chip-bottom-insurance-box chip-bottom-insurance-box-lose" : "chip-bottom-insurance-box"

            return (
                <div className="chip-bottom-insurance">

                    <div className={style}>{title}</div>

                    <div className={loseStyle}>
                        <Chip value={winInsurance} chips={chips} />
                    </div>

                    {/* Win Chip */}
                    {insuranceStatus === "win" &&
                        <div className="chip-bottom-insurance-box-win">
                            <Chip value={winInsurance} chips={chips} />
                        </div>
                    }

                </div>
            )
        }
    }

    /* ANTE */
    _ante = (type) => {

        const { ante, active, isPass, lose, boxStyle, add, expressResult } = this.props

        const ante_style = type === "ante" ? ((ante && !isPass && !lose) ? "hidden" : "") : (ante && !(expressResult && expressResult.multiplier === 0) ? "hidden" : "")
        const isChipsHidden = type === "ante" ? (isPass || lose) : (expressResult && expressResult.multiplier === 0)

        const text = type === "ante" ? "ANTE" : "EXPRESS"
        const backgroundColor = "rgb(33 16 8)"

        return (
            <div onClick={() => add()} className={`chips-bottom-ante mobile ${type}`} style={{ backgroundColor }}>

                <div className={`outer-box`}>
                    {(parseInt(ante) > 0 || parseInt(active) > 0) ? <div className={`chips-bottom-ante-click ${boxStyle}`} /> : null}
                </div>

                {/* Text */}
                <div className={`chips-bottom-ante-text ${ante_style}`}>{text}</div>

                {/* Image */}
                {!isChipsHidden && this._image()}

                {/* On Add Animation */}
                {this._chipAnimations()}

                {/* Result Animation */}
                {this._anteResult(type)}

            </div>
        )

    }


    render = () => {

        /* Fields */
        const { add, isBet, isPass, lose, bet, gameScreen, fromBet } = this.props

        /* Status */
        const style = gameScreen ? "game" : ""
        const betStyle = fromBet ? 'blured' : ''
        const betHidden = isBet && !lose ? "hidden" : ""
        const isChipsHidden = isPass || lose

        const backgroundColor = "rgb(33 16 8)"

        return (
            <div className={`chips-bottom mobile ${style}`}>

                {this._animation()}

                {/* ANTE */}
                {add &&
                    <div className="nmp-rate-mobile">
                        {this._ante("ante")}
                        {this._ante("express")}
                    </div>
                }

                {/* Rate Bet */}
                <div onClick={() => bet()} className={isBet ? `chips-bottom-bet-click chips-bottom-bet mobile ${style} ${betStyle}` : `chips-bottom-bet mobile ${style} ${betStyle}`} style={{ backgroundColor }}>

                    {/* Box */}
                    <div className={`outer-box ${style}`} />

                    {/* Text */}
                    <div className={`chips-bottom-bet-text ${betHidden}`}>BET</div>

                    {/* Chip */}
                    {!isChipsHidden && this._bet()}

                    {/* Result */}
                    {this._betResult()}

                </div>

                {/* Draw Insurance */}
                {this._insurance()}

            </div>
        )
    }
}

export default MobileRate